if (!customElements.get('free-gift-wrapping')) {
  customElements.define('free-gift-wrapping', class FreeGiftWrapping extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('[name="attributes[Free gift wrapping]"]');
      this.loadingOverlay = this.querySelector('.loading-overlay');
      this.miniCart = document.querySelector('mini-cart');
      this.eligible = this.dataset.eligible === 'true';
      this.selected = this.dataset.selected === 'true';
      this.giftWrapId = this.dataset.giftWrapId;
      this.giftWrapsInCart = parseInt(this.dataset.giftWrapsInCart || '0');

      if ((!this.eligible && this.selected) || (this.eligible && this.giftWrapsInCart > 0)) {
        this.updateAttribute(this.eligible && this.selected, true);
        return;
      }

      if (!this.input) return;

      this.input.addEventListener('change', (event) => {
        this.updateAttribute(event.target.checked, false);
      });
    }

    updateAttribute(selected, silent) {
      if (!silent && this.loadingOverlay) {
        this.loadingOverlay.classList.remove('hidden');
      }

      const sections = this.getSectionsToRender().map((section) => section.section).filter(Boolean);
      const body = JSON.stringify({
        updates: this.giftWrapId && this.eligible ? {
          [this.giftWrapId]: 0
        } : undefined,
        attributes: {
          'Free gift wrapping': selected ? 'Yes' : '',
          'Gift wrapping note': selected ? 'Order qualified for free gift wrapping over CAD $99.' : '',
          'gift-wrapping': this.eligible ? '' : undefined,
          'gift-note': this.eligible ? '' : undefined
        },
        sections,
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body })
        .then((response) => response.json())
        .then((response) => {
          if (!silent && this.loadingOverlay) {
            this.loadingOverlay.classList.add('hidden');
          }

          if (document.body.classList.contains('template-cart')) {
            window.location.href = theme.routes.cart_url;
            return;
          }

          if (this.miniCart && response.sections) {
            this.miniCart.renderContents(response);
          }
        })
        .catch((error) => {
          if (!silent && this.loadingOverlay) {
            this.loadingOverlay.classList.add('hidden');
          }

          if (this.input) {
            this.input.checked = !selected;
          }

          console.error(error);
        });
    }

    getSectionsToRender() {
      return [
        {
          id: 'mini-cart',
          section: 'mini-cart',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset.id,
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        }
      ];
    }
  });
}
